import React, { Component } from "react";
import Tooltip from "../../components/UI/TooltipIcon/TooptipIcon";
import orderBy from "lodash/orderBy";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { storyTemplates, staticTitles, profilePicValidityCheck } from "../../utils/constants";
import placeholder from "./../../assets/toolkit-favorite-placeholder.svg";
import {
  Modal,
  ModalBody,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
import reply from "../../assets/stories/reply.svg";
import Select from "react-select";
import "rc-checkbox/assets/index.css";
import EmptyTable from "../../components/EmptyTable/EmptyTable";
import { storyReactions } from "../../utils/constants";
import { MentionsInput, Mention } from "react-mentions";
import "./Stories.css";
import Loading from "../../hoc/Loading/Loading";
import Reactions from "./Reactions.jsx";
import StoryCommentList from "./StoryCommentList.jsx";
import defaultStyle from "./defaultStyle";
import defaultMobileStyle from "./defaultMobileStyle";
import defaultMentionStyle from "./defaultMentionStyle";
import classNames from "./Stories.css";
import Toggle from "react-toggle";
import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import avatarIcon from "../../assets/default-avatar.png";
import If from "../../components/Shared/If";
import classnames from "classnames";
import { isMobile } from "../../utils/deviceInfo";
import FooterBar from "../../components/FooterBar/FooterBar";
import StoryItems from "./StoryItems.jsx";

class Trending extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stories: [],
      archievedStories: [],
      selectedTrending: "reactions",
      privacy: "PUBLIC",
      isAnonymous: false,
      isAnonymousVisible: true,
      emptyState: false,
      disableSubmit: true,
      showReplies: false,
      mentionsSelected: [],
      mentionsFound: [],
      showResponses: [],
      isCommentsOpen: null,
      responseCounter: 0,
      disableSubmit: true,
      showUserReactions: false,
      showReactions: null,
      reactionCounter: 0,
      reactionList: [],
      userReacted: "null",
      mentionWord: "",
      storyType: "Story",
      item: null,
      userReactions: [],
      description: {
        value: "",
        error: false,
      },
      response: "",
      topics: [],
      mentionBool: false,
      mentionsIndex: 0,
      dropdownOpen: false,
      title: "",
      showCreateStoryModal: false,
      modalActionType: "Create",
      categoryDefinitionPopoverOpen: false,
      collapseCompleted: true,
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: "",
      isLoadingComplete: false,
    };
  }

  componentDidMount() {
    this.getTopics();

    if (isMobile)
      this.props.updateNavBar({
        title: "Trending Posts",
        hasBack: true,
        backButton: "<b>Back</b>",
        showNotification: true,
        className: null,
        isBreadCrumbs: false,
      });
  }
  getTopics = () => {
    let orgId = this.props.user.profile.organizationId._id;
    axios.get(url.getTopics(orgId)).then(({ data }) => {
      let foundtopic = data.data;
      this.setState({
        topics: [...foundtopic],
      });
      let id = this.props.match.params.id;
      this.getTrending("reactions");
    });
  };

  getTrending = value => {
    let val = value;
    let orgId = this.props.user.profile.organizationId._id;

    this.setState({ selectedTrending: val });

    axios.get(url.getTrending(orgId, val)).then(({ data }) => {
      let item = data.data[0];

      if (data && data.data[0]) {
        this.setState({
          responseCounter: item.storyCounter,
          disableSubmit: true,
          showUserReactions: false,
          emptyState: false,
          showReactions: null,
          isLoadingComplete: true,
          item,
          reactionCounter:
            item.reactionArr &&
            item.reactionArr.reactions &&
            item.reactionArr.reactions.length > 0
              ? item.reactionArr.reactions.length
              : 0,
          reactionList:
            item.reactionArr &&
            item.reactionArr.reactions &&
            item.reactionArr.reactions.length > 0
              ? item.reactionArr.reactions.slice(0, 3)
              : [],
          userReacted:
            item.reactionArr &&
            item.reactionArr.reactions &&
            item.reactionArr.reactions.length > 0
              ? item.reactionArr.reactions.filter(e => {
                  return e.userId === this.props.user.profile._id;
                })
              : "null",
        });
        this.showStoryComments(item._id);
      } else {
        this.setState({ item: [], emptyState: true, isLoadingComplete: true });
      }
    });
  };

  toggleDropdown = id => {
    let { dropdownOpen } = this.state;
    if (dropdownOpen === id) {
      this.setState({ dropdownOpen: "" });
    } else {
      this.setState({ dropdownOpen: id });
    }
  };

  handleCreateStoryResponse = () => {
    const { description, isAnonymous, privacy, item, title, mentionsSelected } =
      this.state;
    let dValue = description.value
      .replace(/<\/?![^>]+(>|$)/g, "")
      .replace(/[\. ,:-]+/g, "");
    let isUrl;
    if (dValue.length > 0) {
      let desc = `<span> ${description.value.replace(
        /<\/?![^>]+(>|$)/g,
        ""
      )} </span>`;
      let sanitizedDescription = {};
      let mentionsText = `<span>${description.value.replace(
        /<\/?![^>]+(>|$)/g,
        ""
      )}</span>`;
      sanitizedDescription.value = `${description.value.replace(
        /<\/?![^>]+(>|$)/g,
        ""
      )}`;
      sanitizedDescription.userReferences = [];
      let isMention = false;

      let desArr = desc.split(" ");

      let mArray = desArr.filter(e => {
        if (e.indexOf("@") > -1) {
          return e;
        }
      });

      let mentions = mentionsSelected.filter(e => {
        let valMention = `({ "_id": "${e._id}", "email": "${e.email}", "name": "${e.name}"})`;
        // let wLength = word.length
        if (desc.includes(valMention)) {
          let strReplace = `@[@${e.name}]({ "_id": "${e._id}", "email": "${e.email}", "name": "${e.name}"})`;
          desc = desc.replace(
            strReplace,
            `<a class="userMentionWord" href="/home/${this.props.user.profile.organizationId._id}/profile/${e._id}">@${e.name}</a>`
          );

          sanitizedDescription.value = sanitizedDescription.value.replace(
            strReplace,
            `@${e.name}`
          );
          sanitizedDescription.userReferences.push(e._id);
          isMention = true;
          return e;
        }
      });

      let splitDesc = desc.split(" ").map(e => {
        let val = e;
        if (e.indexOf("http") > -1 && e.indexOf("www") == -1) {
          isUrl = true;
          val = e.replace(
            /((http|https)?:\/\/[^\s]+)/g,
            `<a class="urlLink" href='$1' target='_blank' >$1</a>`
          );
        } else if (e.indexOf("www") > -1 && e.indexOf("http") == -1) {
          isUrl = true;
          val = e.replace(
            /(www[^\s]+)/g,
            `<a class="urlLink" href='${"https://"}$1' target='_blank' >$1</a>`
          );
        } else if (e.indexOf("www") > -1 && e.indexOf("http") > -1) {
          isUrl = true;
          val = e.replace(
            /((http|https)[^\s]+)/g,
            `<a class="urlLink" href='$1' target='_blank' >$1</a>`
          );
        }
        return val;
      });

      desc = splitDesc.join(" ");

      if (desc.length > 0) {
        let payload = { description: desc, title, isAnonymous, privacy };
        if (isAnonymous) {
          payload.isAnonymous = isAnonymous;
        } else if (isAnonymous === undefined) {
          payload.isAnonymous = false;
        }
        if (mentions && mentions.length > 0) {
          payload.users = mentions;
        }
        payload.parent = item._id;
        payload.isMention = isMention;
        payload.sanitizedDescription = sanitizedDescription;
        payload.mentionsText = mentionsText;
        // return

        axios
          .post(url.createStoryResponse(item._id), payload)
          .then(({ data }) => {
            this.props.storyMetricsChange({ type: "replies", value: 1 });
            this.setState(prevState => ({
              description: "",
              title: "",
              privacy: true,
              isAnonymous: false,
              mentionsSelected: [],
              mentionsFound: [],
              mentionWord: "",
              showReplies: false,
              isCommentsOpen: true,
              responseCounter: prevState.responseCounter + 1,
            }));

            this.showStoryComments(item._id);
          });

        this.setState({
          showCreateStoryModal: false,
          description: "",
          title: "",
          privacy: true,
        });
      } else {
        this.setState({ showCreateStoryModal: true });
      }
    }
  };

  handleChangeStoryDescription = event => {
    let descriptionContext = event.target.value;

    let word, value;

    let { mentionsFound, mentionWord } = this.state;
    if (descriptionContext === "") {
      word = [];
      value = "";
    } else {
      word = mentionsFound;
      value = mentionWord;
    }
    let valCheck = event.target.value
      .replace(/<\/?![^>]+(>|$)/g, "")
      .replace(/[\. ,:-]+/g, "")
      .replace(/^\n|\n$/g, "");

    this.setState({
      description: { value: descriptionContext },
      mentionWord: value,
      mentionsFound: word,
      disableSubmit: valCheck.length === 0,
    });
  };

  selectUserMention = val => {
    let obj = JSON.parse(val);
    this.setState(prevState => ({
      mentionsFound: [],
      mentionWord: "",
      // description: {value: text},
      mentionsSelected: [...prevState.mentionsSelected, obj],
    }));
  };

  fetchUsers = (query, callback) => {
    let users;
    if (!query) return;
    axios
      .get(url.findUser(query))
      .then((resp, idx) =>
        resp.data.data.map(user => ({
          display: "@" + user.firstName + " " + user.lastName,
          id: `{ "_id": "${user._id}", "email": "${user.email}", "name": "${
            user.firstName + " " + user.lastName
          }"}`,
          // {_id:user._id, email: user.email, idx},
          // name: user.firstName + " " + user.lastName,
          // _id: user._id,
          // email: user.email,
        }))
      )
      .then(callback);
  };

  handlePermissionChange = changeEvent => {
    this.setState({
      isAnonymous: changeEvent.target.checked,
    });
  };

  archiveStory = (id, actionType) => {
    actionType === "Archive" ? this.deleteStory(id) : this.deArchiveStory(id);
    this.toggleDropdown(id);
  };

  deleteStory = id => {
    let { selectedTrending } = this.state;
    axios.put(url.archiveStory(id)).then(data => {
      //   this.props.getStoryFeeds();
      this.setState({
        dropdownOpen: false,
        // emptyState:true,
      });
      if (selectedTrending === "replies") {
        this.getTrending("replies");
      } else {
        this.getTrending("reactions");
      }
    });
  };

  editParticularStoryobj = story => {
    const { stories } = this.state;
    let storiesArray = [...stories];
    const storyIndex = storiesArray.findIndex(x => x._id === story._id);

    if (storyIndex >= 0) {
      storiesArray[storyIndex] = { ...storiesArray[storyIndex], ...story };

      this.setState({ stories: [...storiesArray] });
    }
  };

  deArchiveStory = id => {
    axios.put(url.deArchiveStory(id)).then(data => {
      //   this.props.getStoryFeeds();
      const result = data;
      this.setState({
        dropdownOpen: false,
      });
    });
  };

  removeStoryConfirmation = (id, type) => {
    let { item } = this.state;
    let { user } = this.props;
    // return
    this.setState({ showRemoveFeedConfirmationModal: false });

    axios.put(url.removeStoryFeeds(id, type)).then(resp => {
      if (type && type.toLowerCase() === "story") {
        this.setState({
          emptyState: true,
        });
      }
      this.setState({
        dropdownOpen: false,
      });

      if (
        resp.data.data.parentStory &&
        resp.data.data.parentStory.item &&
        resp.data.data.type === "storyResponse"
      ) {
        if (item.userId === user.profile._id)
          this.props.storyMetricsChange({ type: "replies", value: -1 });
        this.setState(prevState => ({
          responseCounter: prevState.responseCounter - 1,
        }));
        this.showStoryComments(resp.data.data.parentStory.item);
      } else {
        if (item.userId === user.profile._id)
          this.props.storyMetricsChange({ type: "story", value: -1 });
      }
    });
  };

  showStoryRemoveConfirmation = (storyId, storyType) => {
    this.setState({
      showRemoveFeedConfirmationModal:
        !this.state.showRemoveFeedConfirmationModal,
      storyIdRemove: storyId,
      storyType: storyType,
    });
  };

  closeStoryRemoveConfirmation = storyId => {
    this.setState({
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: "",
    });
  };

  createMarkup = input => {
    return { __html: `${input}` };
  };

  createResponse = () => {
    this.setState(prevState => ({
      showReplies: !prevState.showReplies,
      showReactions: false,
    }));
  };

  showStoryComments = item => {
    let itm = item;
    this.setState({ showReactions: false });
    if (this.state.isCommentsOpen !== false) {
      axios.get(url.getStoryComments(itm)).then(({ data }) => {
        let arr = data.data.storyList;
        this.setState(prevState => ({
          showResponses: arr,
          isCommentsOpen: false,
        }));
      });
    } else {
      this.setState(prevState => ({
        isCommentsOpen: true,
      }));
    }
  };

  navigateLink = e => {
    let className = e.target.className;

    if (isMobile && className == "userMentionWord") {
      e.preventDefault();
    }

    // if(className!=="urlLink"){
    //    e.preventDefault()

    //   let idx= e.target.href.indexOf('home')-1
    //   let link = e.target.href.slice(idx)
    //   this.props.history.push(link);
    // }
  };

  addReaction = val => {
    let { user } = this.props;
    let { reactionList, item, userReactions, reactionCounter } = this.state;

    let payload = {
      userId: user.profile._id,
      reaction: val,
      _id: val,
      user: user.profile,
      createdOn: Date.now,
      storyId: item._id,
      storyOwner: item.userId,
      orgId: user.profile.organizationId._id,
    };

    // if(this.state.reactionList.indexOf(payload.userId)>-1)
    let rList = reactionList;
    let uR = userReactions;
    let isReactionListModified = false;
    let isUserListModified = false;

    rList.map(e => {
      if (e.userId === payload.userId) {
        e.reaction = payload.reaction;
        isReactionListModified = true;
      }
    });

    uR.map(e => {
      if (e.user._id === payload.userId) {
        e.reaction = val;
        e._id = val;
        e.user.firstName = payload.user.firstName ? payload.user.firstName : "";
        e.user.lastName = payload.user.lastName ? payload.user.lastName : "";
        e.user.profilePic = profilePicValidityCheck(payload.user.profilePic)
          ? payload.user.profilePic
          : "";
        isUserListModified = true;
      }
    });

    if (isReactionListModified) {
      this.setState(prevState => ({
        reactionList: [...rList],
      }));
    } else {
      if (reactionList.length < 3) {
        this.setState(prevState => ({
          reactionList: [
            { reaction: val, userId: user.profile._id },
            ...prevState.reactionList,
          ],
          reactionCounter: prevState.reactionCounter + 1,
        }));
      } else {
        this.setState(prevState => ({
          reactionCounter: prevState.reactionCounter + 1,
        }));
      }
    }

    if (isUserListModified) {
      this.setState(prevState => ({
        userReactions: [...uR],
      }));
    } else {
      this.setState(prevState => ({
        userReactions: [payload, ...prevState.userReactions],
      }));
    }

    axios.post(url.addReaction(item._id), payload).then(({ data }) => {
      this.props.storyMetricsChange({ type: "reactions", value: 1 });
    });
  };

  trendingCheck = val => {
    let { selectedTrending } = this.state;
    this.setState({
      isCommentsOpen: true,
      showStoryComments: [],
    });
    if (selectedTrending !== val) {
      this.getTrending(val);
    }
  };

  pickImage = val => {
    let selected = storyReactions.filter(x => x._id === val)[0];
    return selected.image;
  };

  showReactionList = () => {
    const { item } = this.state;
    axios.get(url.userReactions(item._id)).then(({ data }) => {
      let value = data.data;
      if (value.storyList && value.storyList.length > 0) {
        this.setState(prevState => ({
          showUserReactions: true,
          userReactions: [...value.storyList],
        }));
      } else if (this.state.userReactions.length > 0) {
        this.setState(prevState => ({
          showUserReactions: true,
          userReactions: [...prevState.userReactions],
        }));
      }
    });
  };

  removeReactionHover = () => {
    this.setState(prevState => ({
      showReactions: false,
    }));
  };

  closeReactionModal = () => {
    this.setState({ showUserReactions: false });
  };

  removeReaction = () => {
    let { selectedTrending } = this.state;
    let userId = this.props.user.profile._id;
    let storyId = this.state.item._id;
    let userRlist = this.state.userReacted;
    let reactionList = this.state.reactionList;

    if (userRlist.length > 0) {
      let ulist = userRlist.filter(
        e => e.userId != this.props.user.profile._id
      );
      this.setState({ userReacted: [...ulist] });
    }

    if (reactionList.length > 0) {
      let rlist = reactionList.filter(
        e => e.userId != this.props.user.profile._id
      );
      this.setState(prevState => ({
        reactionList: [...rlist],
        reactionCounter: prevState.reactionCounter - 1,
      }));
    }

    axios.delete(url.deleteReaction(storyId, userId)).then(({ data }) => {
      this.props.storyMetricsChange({ type: "reactions", value: -1 });

      if (
        data.data.reactionArr.reactions.length === 0 &&
        selectedTrending === "reactions"
      ) {
        this.getTrending("reactions");
      }
    });
  };

  showTopicName = topic => {
    let { topics } = this.state;
    if (topic) {
      let res = topics.filter(e => e._id === topic._id);
      if (res && res[0]) {
        return res[0].name;
      }
    }
  };

  editStory = story => {
    // this.props.showCreateStory()
  };

  goToProfile = profilePicSrc => {
    if (isMobile) return;
    let link = "";
    // console.log(this.props.officeMate)
    if (this.state.item.userId === this.props.user.profile._id) {
      // dynamic_urls
      this.props.history.push(
        `/home/${this.state.item.organizationId}/profile/${this.state.item.userId}`
      );
      // this.props.history.push({
      //     pathname:
      // });
    } else {
      this.props.history.push(
        `/home/${this.state.item.organizationId}/profile/${this.state.item.userId}`
      );
    }
  };

  returnSiteName = () => {
    const { item } = this.state;
    if (item) {
      if (item.ogp && item.ogp !== "undefined" && item.ogp !== null) {
        let { ogp } = item;

        let { ogUrl, twitterAppNameGooglePlay, ogSiteName } = ogp;

        let startNameURL = ogUrl.indexOf("w.") + 2;
        let endNameURL = ogUrl.indexOf(".com");
        let startEndDiff = endNameURL - startNameURL;
        let siteName = ogUrl.substr(startNameURL, startEndDiff);

        if (ogSiteName) {
          return ogSiteName;
        } else if (twitterAppNameGooglePlay) {
          return twitterAppNameGooglePlay;
        } else {
          return siteName;
        }
      }
    }
  };

  renderNoContent = () => {
    let { selectedTrending } = this.state;
    return (
      <div className="trending_story_page_container">
        {/* <If condition={!isMobile}>
     <span className="singleStory" onClick={()=> this.props.history.push('/home/stories')} >
     {staticTitles.stories}
     </span>
      <span className="singleStoryName">> Trending </span>
      </If> */}
        <div className="trendingStoriesTitle">
          Trending {staticTitles.storyItemsU}
        </div>

        <span className="trendingContent2"> Trending post with the most: </span>

        <div className="trendingCategoryContainer">
          <div className="storyGroupContainerFeature">
            <div
              className={
                selectedTrending === "reactions"
                  ? "storyGroupsSelectedFeature reactionsBorder"
                  : "reactionsBorder storyGroupsFeature"
              }
              onClick={() => this.trendingCheck("reactions")}
            >
              Reactions
            </div>
          </div>
          <div className="storyGroupContainerFeature">
            <div
              className={
                selectedTrending === "replies"
                  ? "storyGroupsSelectedFeature repliesBorder"
                  : "repliesBorder storyGroupsFeature"
              }
              onClick={() => this.trendingCheck("replies")}
            >
              Replies
            </div>
          </div>
        </div>

        <div className="mt20 trendingEmpty noStories">
          <img src={placeholder} />

          {selectedTrending === "reactions" ? (
            <div>
              There are no {staticTitles.storyItemsL} with any reactions right
              now. You can add a Reaction to a post right now, and the post will
              show up here!
            </div>
          ) : (
            <div>
              There are no {staticTitles.storyItemsL} with any replies right
              now. You can add a Comment to a post right now, and the post will
              show up here!
            </div>
          )}
          <If condition={!isMobile}>
            <div onClick={() => this.props.history.push("/home/stories")}>
              <span className="singleStoryBtn">
                Back to {staticTitles.stories}
              </span>
            </div>
          </If>
          {/* <EmptyTable title="No trending stories" subtitle="Write a story this week and see it trend."/> */}
        </div>
      </div>
    );
  };

  renderStories = () => {
    const isAdmin =
      this.props.user.profile.role === "Admin" ||
      this.props.user.profile.role === "SuperAdmin";

    const { orgAdmin } = this.props.user.profile;
    // const { item, actionType, avatar } = this.state;
    // let {isArchived}=this.props
    let {
      isCommentsOpen,
      emptyState,
      item,
      selectedTrending,
      actionType,
      avatar,
      description,
      showUserReactions,
      isLoadingComplete,
      isAnonymous,
      disableSubmit,
      reactionList,
      showResponses,
      responseCounter,
    } = this.state;
    const createStoryModalStyle = classnames(
      "addStoryComment btn btn-primary",
      {
        disabled: disableSubmit,
      }
    );

    if (isLoadingComplete) {
      if (item && item !== [] && emptyState !== true) {
        let itemTemplate = storyTemplates.filter(val => {
          if (item.template && item.template._id) {
            return item.template._id === val._id ? val : null;
          } else {
            return null;
          }
        });

        return (
          <div
            style={{ marginBottom: "2em" }}
            // className="trending_story_page_container"
          >
            <div className="trendingStoriesContainer">
              <div className="trendingStoriesTitle">
                Trending {staticTitles.storyItemsU}
              </div>

              <span className="trendingContent2">
                Trending {staticTitles.storyItemsL} with the most:{" "}
              </span>

              <div className="trendingCategoryContainer">
                <div className="storyGroupContainerFeature">
                  <div
                    className={
                      selectedTrending === "reactions"
                        ? "storyGroupsSelectedFeature reactionsBorder"
                        : "reactionsBorder storyGroupsFeature"
                    }
                    onClick={() => this.trendingCheck("reactions")}
                  >
                    Reactions
                  </div>
                </div>
                <div className="storyGroupContainerFeature">
                  <div
                    className={
                      selectedTrending === "replies"
                        ? "storyGroupsSelectedFeature repliesBorder"
                        : "repliesBorder storyGroupsFeature"
                    }
                    onClick={() => this.trendingCheck("replies")}
                  >
                    Replies
                  </div>
                </div>
              </div>
            </div>

            <StoryItems
              showCreateStory={() => this.editStory(item)}
              removeStoryFeeds={this.removeStoryConfirmation}
              deArchiveStory={this.deArchiveStory}
              archiveStory={this.archiveStory}
              filters={this.state.topics}
              // getStoryFeeds={this.getStoryFeeds}
              key={item._id}
              item={item}
              actionType={actionType}
              avatar={
                item.isAnonymous
                  ? avatarIcon
                  : profilePicValidityCheck(item.profilePic)
                  ? item.profilePic
                  : avatarIcon
              }
              description={item.description}
              editParticularStoryobj={this.editParticularStoryobj}
            />
          </div>
        );
      } else {
        return this.renderNoContent();
      }
    } else {
      return (
        <div className="trending_story_page_container">
          {/* <If condition={!isMobile}>
     <span className="singleStory" onClick={()=> this.props.history.push('/home/stories')} >
     {staticTitles.stories}
     </span>
      <span className="singleStoryName">> Trending </span>
      </If> */}
          <div className="trendingStoriesTitle">
            Trending {staticTitles.storyItemsU}
          </div>

          <span className="trendingContent2">
            {" "}
            Trending post with the most:{" "}
          </span>

          <div className="trendingCategoryContainer">
            <div className="storyGroupContainerFeature">
              <div
                className={
                  selectedTrending === "reactions"
                    ? "storyGroupsSelectedFeature reactionsBorder"
                    : "reactionsBorder storyGroupsFeature"
                }
                onClick={() => this.trendingCheck("reactions")}
              >
                Reactions
              </div>
            </div>
            <div className="storyGroupContainerFeature">
              <div
                className={
                  selectedTrending === "replies"
                    ? "storyGroupsSelectedFeature repliesBorder"
                    : "repliesBorder storyGroupsFeature"
                }
                onClick={() => this.trendingCheck("replies")}
              >
                Replies
              </div>
            </div>
          </div>

          <div className="mt20 trendingEmpty noStories">
            <img src={placeholder} />

            <div> Loading Trending content </div>

            {/* {selectedTrending==="reactions"?
        <div>There are no {staticTitles.storyItemsL} with any reactions right now. You can add a Reaction to a post right now, and the post will show up here!</div>
      :
        <div>There are no {staticTitles.storyItemsL} with any replies right now. You can add a Reply to a post right now, and the post will show up here!</div>
      }
     */}
          </div>
        </div>
      );
    }
  };

  getStoriesCount = () => {
    const filteredStories = this.state.stories.filter(
      story => !story.isDeleted
    );
    return filteredStories.length;
  };

  handleCollapse = () => {
    this.setState(state => ({ collapseCompleted: !state.collapseCompleted }));
  };

  render() {
    const {
      description,
      isAnonymous,
      disableSubmit,
      stories,
      collapseCompleted,
      categoryDefinitionPopoverOpen,
      archievedStories,
      showRemoveFeedConfirmationModal,
      isLoadingComplete,
    } = this.state;
    const createStoryModalStyle = classnames(
      "addStoryComment btn btn-primary",
      {
        disabled: disableSubmit,
      }
    );

    return (
      <div
        className={`stories ${isMobile ? "mt10" : "ml-3"}`}
        onMouseLeave={this.removeReactionHover}
      >
        {this.renderStories()}

        {isMobile && <FooterBar {...this.props} />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    storyMetricsChange: data =>
      dispatch(actionCreators.storyMetricsChange(data)),

    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(Trending, axios)));
